import { render, staticRenderFns } from "./Pagination_vue.vue?vue&type=template&id=0f37f812&"
import script from "./Pagination_vue.vue?vue&type=script&lang=js&"
export * from "./Pagination_vue.vue?vue&type=script&lang=js&"
import style0 from "./Pagination_vue.vue?vue&type=style&index=0&id=0f37f812&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports